import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import Place from "../../Models/Place";
import "./Modal.css";
import "./MultiSelectModal.css";
import store from "../../store/store";
import { selectOne } from "../../store/reducer";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";

const PHOTO_FALLBACK = "/Icons/place.jpg";

const MultiSelectModal = (props) => {
  const [show] = useState(true);
  const [SearchText, setSearchText] = useState("");

  const [LocalItems, setLocalItems] = useState(props.MultiselectItems);
  const [DisplayedItems, setDisplayedItems] = useState([]);
  const [LocalSelectedItems, setLocalSelectedItems] = useState(props.MultiselectSelectedItems);
  const [LocalSearchText, setLocalSearchText] = useState(props.MultiselectSearchText);
  const MultiselectMode = props.MultiselectMode;
  const MultiselectDisplayMode = props.MultiselectDisplayMode || "list";
  const MultiselectCallback = props.MultiselectCallback;
  //const MultiselectTitle = useSelector((state) => state.MultiselectTitle);
  const MultiselectTitle = props.MultiselectTitle;
  const MultiselectOnEdit = props.onEdit || null;

  const dispatch = useDispatch();

  useEffect(() => {
    let MultiselectItems = JSON.parse(JSON.stringify(props.MultiselectItems));
    let MultiselectSelectedItems = JSON.parse(JSON.stringify(props.MultiselectSelectedItems));
    if (!Array.isArray(MultiselectItems)) MultiselectItems = [MultiselectItems];

    //if MultiselectItems is an array of strings
    if (MultiselectItems.length > 0 && typeof MultiselectItems[0] == "string") {
      let _MultiselectItems = [];
      MultiselectItems.forEach((item) => {
        _MultiselectItems.push({
          label: item,
          value: item,
        });
      });
      MultiselectItems = _MultiselectItems;
    }

    //if id is not in object, add id
    if (MultiselectItems.length > 0 && typeof MultiselectItems[0].id == "undefined") {
      let id = 0;
      MultiselectItems.forEach((item) => {
        item.id = (id++).toString();
      });
    }

    if (!Array.isArray(MultiselectSelectedItems)) MultiselectSelectedItems = [MultiselectSelectedItems];

    //if MultiselectSelectedItems is an array of strings
    if (MultiselectSelectedItems.length > 0 && typeof MultiselectSelectedItems[0] == "string") {
      let _MultiselectSelectedItems = [];
      MultiselectSelectedItems.forEach((item) => {
        _MultiselectSelectedItems.push({
          label: item,
          value: item,
        });
      });
      MultiselectSelectedItems = _MultiselectSelectedItems;
    }

    //if id is not in MultiselectSelectedItems object add id
    if (MultiselectSelectedItems.length > 0 && typeof MultiselectSelectedItems[0].id == "undefined") {
      MultiselectSelectedItems.forEach((item) => {
        // Prefer matching by value (guaranteed unique, e.g. a uid) over
        // label, which can collide when two different underlying things
        // render with the same display text (e.g. two people sharing a
        // name or the same email-fallback label) — a label match alone
        // would silently pre-check the wrong one. Label stays as a
        // fallback for callers whose "selected" item has no real
        // distinguishing value (value === label, e.g. a plain string like
        // a country name). Found 2026-10-01.
        let index = MultiselectItems.findIndex((x) => x.value === item.value);
        if (index === -1) index = MultiselectItems.findIndex((x) => x.label === item.label);
        if (index !== -1) {
          item.id = MultiselectItems[index].id;
        }
      });
    }

    MultiselectItems.forEach((item) => {
      item.checked = false;
    });
    //console.log("***********************************");
    if (typeof LocalSearchText === "string" && LocalSearchText !== "") {
      let temp_list = [];
      const _searchText = LocalSearchText.toUpperCase();
      MultiselectItems.forEach((item) => {
        // Catch-all rows like "Type a different city…" (AISearch.js,
        // AiDialog.js, WalkAI.js, DestinationsScreen.js, PlaceEditModal.js,
        // ImportConfirmationModal.js all use this exact "…" convention)
        // must survive every search — they're the fallback for exactly the
        // case where nothing else matches. Ported from mobile's identical
        // fix. Found/fixed 2026-09-14.
        if (item.label.endsWith("…") || item.label.toUpperCase().includes(_searchText)) temp_list.push(item);
      });
      MultiselectItems = temp_list;
    }

    //Check the items that are selected
    MultiselectSelectedItems.forEach((item) => {
      if (typeof item.id == "undefined") {
        const index = MultiselectItems.findIndex((x) => x.value === item.value);
        if (index !== -1) MultiselectItems[index].checked = true;
      } else {
        const index = MultiselectItems.findIndex((x) => x.id === item.id);
        if (index !== -1) MultiselectItems[index].checked = true;
      }
    });
    setLocalItems(MultiselectItems);
    setDisplayedItems(MultiselectItems);
    setLocalSelectedItems(MultiselectSelectedItems);
    // Also on MultiselectSelectedItems (2026-10-20): callers dispatch the
    // items and then the pre-ticked ones as separate updates, and when the
    // second arrived in a later render it was ignored — the list showed
    // nothing ticked and Done returned nothing (Import Places from Other
    // Guides just stopped).
  }, [props.MultiselectItems, props.MultiselectSelectedItems]);

  function handleChange(value) {
    const index = LocalItems.findIndex((x) => x.value === value);
    if (index === -1) return;
    //console.log("**************handleChange");
    if (MultiselectMode === "uni") {
      setLocalSelectedItems([LocalItems[index]]);
      // LocalSearchText passed as a 2nd arg — callers with a "Type a
      // different city…"-style catch-all item can pre-fill their own
      // free-text prompt with whatever the user already typed here to find
      // it, instead of making them retype it. Ported from mobile's
      // identical fix. Found/added 2026-09-14.
      if (MultiselectCallback != null) MultiselectCallback([LocalItems[index]], LocalSearchText);
      props.onHide();
      return;
    }
    // let _MultiselectItems = LocalItems;
    // let newSelected = [];
    LocalItems[index].checked = !LocalItems[index].checked;
    handleSearchChanged(LocalSearchText);
    // _MultiselectItems.forEach((item) => {
    //   if (item.checked === true) newSelected.push(item);
    // });

    // setLocalSelectedItems(newSelected);
    // setDisplayedItems(_MultiselectItems);
  }

  function handleOK() {
    let temp_list = [];
    LocalItems.forEach((item) => {
      if (item.checked === true) temp_list.push(item);
    });
    if (MultiselectCallback != null) MultiselectCallback(temp_list);
    props.onHide();
  }

  const handleSelectAll = () => {
    let count = 0;
    LocalItems.forEach((item) => {
      if (item.checked === true) count++;
    });
    let newVal = true;
    if (count > 0) newVal = false;
    LocalItems.forEach((item) => {
      item.checked = newVal;
    });
    let newSelected = [];
    LocalItems.forEach((item) => {
      if (item.checked === true) newSelected.push(item);
    });

    setLocalSelectedItems(newSelected);
    setDisplayedItems(LocalItems);
  };

  const handleSearchChanged = (searchText) => {
    setLocalSearchText(searchText);
    let temp_list = [];
    const _searchText = searchText.toUpperCase();
    LocalItems.forEach((item) => {
      // Same "…" catch-all exemption as the effect above — see its comment.
      if (item.label.endsWith("…") || item.label.toUpperCase().includes(_searchText) || searchText === "") temp_list.push(item);
    });
    setDisplayedItems(temp_list);
  };

  return (
    <div className="modal">
      <Modal
        show={props.show}
        onHide={props.onHide}
        dialogClassName="msm-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered={false}
        scrollable={false}
        animation={false}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="msm-shell">

            <div className="msm-header">
              <div className="msm-header-icon">
                <FontAwesomeIcon icon={solid("list-check")} />
              </div>
              <h2 className="msm-title">{MultiselectTitle}</h2>
              {MultiselectMode !== "uni" ? (
                <button className="msm-done-btn" onClick={handleOK}>
                  <FontAwesomeIcon icon={solid("check")} />
                  Done
                </button>
              ) : null}
              <button className="msm-close" onClick={props.onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            <div className="msm-search-row">
              <div className="msm-search">
                <FontAwesomeIcon icon={solid("magnifying-glass")} className="msm-search-icon" />
                <input
                  type="text"
                  value={LocalSearchText}
                  placeholder="Search"
                  onChange={(e) => handleSearchChanged(e.target.value)}
                  // Only steal focus for lists long enough that searching is
                  // actually useful — for a short list the keyboard/cursor
                  // jump is just a nuisance. Matches mobile's MultiSelect.js.
                  autoFocus={LocalItems.length > 15}
                />
                {LocalSearchText !== "" && (
                  <button
                    type="button"
                    className="msm-search-clear"
                    onClick={() => handleSearchChanged("")}
                    aria-label="Clear search"
                  >
                    <FontAwesomeIcon icon={solid("xmark")} />
                  </button>
                )}
              </div>
              {MultiselectMode === "multi" ? (
                <button className="msm-tool-btn" title="Select / deselect all" onClick={handleSelectAll}>
                  <FontAwesomeIcon icon={solid("check-double")} />
                </button>
              ) : null}
              {MultiselectOnEdit ? (
                <button className="msm-tool-btn" title="Edit" onClick={MultiselectOnEdit}>
                  <FontAwesomeIcon icon={solid("pen-to-square")} />
                </button>
              ) : null}
            </div>

            {MultiselectDisplayMode === "photo-grid" ? (
              <div className="msm-photo-grid">
                {DisplayedItems.map((element, index) => (
                  <div
                    className={`msm-photo-item${element.checked ? " active" : ""}`}
                    key={index}
                    onClick={() => handleChange(element.value)}
                  >
                    <div className="msm-photo-thumb-wrap">
                      <img
                        className="msm-photo-thumb"
                        alt={element.label}
                        src={element.thumb || element.value || PHOTO_FALLBACK}
                        referrerPolicy="no-referrer"
                        onError={(e) => {
                          if (element.thumbFallback && e.target.src !== element.thumbFallback) {
                            e.target.src = element.thumbFallback;
                          } else {
                            e.target.src = PHOTO_FALLBACK;
                          }
                        }}
                      />
                      {element.checked && (
                        <div className="msm-photo-check">
                          <FontAwesomeIcon icon={solid("check")} />
                        </div>
                      )}
                    </div>
                    <span className="msm-photo-label">{element.label}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="msm-list">
                {DisplayedItems.map((element, index) => {
                  const iconSrc = element.icon != null && typeof element.icon != "undefined"
                    ? Place.getItemPOIImage(element.value)
                    : null;
                  const showCheck = MultiselectMode === "multi" || (MultiselectMode === "uni" && element.checked);
                  return (
                    <div className={`msm-item${element.placeRow ? " msm-item-place" : ""}`} key={index} onClick={() => handleChange(element.value)}>
                      {/* Optional place details (2026-10-17, Common/placeRow.js):
                          a photo, category · visit length, a line of notes and
                          a must-see star — so a place can be recognised, not
                          just its name. Only rows that carry `placeRow`. */}
                      {element.placeRow ? (
                        element.placeRow.thumb
                          ? <img className="msm-item-thumb" alt="" src={element.placeRow.thumb} loading="lazy" referrerPolicy="no-referrer" onError={(e) => { e.target.style.visibility = "hidden"; }} />
                          : <div className="msm-item-thumb" aria-hidden="true" />
                      ) : iconSrc != null ? (
                        <div className="msm-item-icon">
                          <img alt="" src={iconSrc} />
                        </div>
                      ) : element.icon != null && typeof element.icon != "undefined" ? (
                        <div className="msm-item-icon">{element.icon}</div>
                      ) : null}
                      <div className="msm-item-text">
                        <span className="msm-item-label">
                          {element.placeRow?.star && <FontAwesomeIcon icon={solid("star")} className="msm-item-star" title="Must see" />}
                          {element.label}
                        </span>
                        {element.placeRow?.meta ? <span className="msm-item-meta">{element.placeRow.meta}</span> : null}
                        {element.placeRow?.desc ? <span className="msm-item-desc" title={element.placeRow.fullDesc || element.placeRow.desc}>{element.placeRow.desc}</span> : null}
                        {/* Optional per-item badges (icon + short text) — e.g.
                            EventEdit.js's place picker uses this for distance/
                            opening-hours/already-scheduled instead of baking
                            that into the label string itself, which is what
                            was overflowing and truncating on a small screen.
                            Every other caller of this shared list just omits
                            `badges`, so this renders nothing extra for them.
                            Found 2026-09-30. */}
                        {element.badges && element.badges.length > 0 && (
                          <div className="msm-item-badges">
                            {element.badges.map((b, bi) => (
                              <span key={bi} className={`msm-item-badge${b.tint ? " " + b.tint : ""}`}>
                                <FontAwesomeIcon icon={b.icon} />
                                {b.text}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                      {showCheck ? (
                        <div className={`msm-check${element.checked ? " active" : ""}`}>
                          {element.checked && <FontAwesomeIcon icon={solid("check")} />}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}

          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MultiSelectModal;
